<template>
  <div>
    <h1>Hello Department Page!</h1>
  </div>
</template>
